import _ from 'lodash';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField'; // , { TextFieldProps }
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
// import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { isNumeric, zeroIsOk } from '../../utils/helpers';
import Icon from './Icon';
// import DateUtil from '../../utils/date';
import { formatPhone } from '../../utils/format';
// import CreatableSelect from 'react-select/creatable';
import Autocomplete from '@mui/material/Autocomplete';

/*
usage:
  <Input
    autoFocus={true||false}
    field={FieldDef.name("").get()}
    disabled={(!values.id && !canCreate) || (!!values.id && !canUpdate)}
    values={local_values}
    errors={errors}
    setValues={data => {
      setValues(data);
      onChange(data);
    }}
    onEnter={onEnter}
    lookups={lookups}
  />
*/

const Input = (props: any) => {
  const {
    field,
    values,
    setValues,
    errors,
    // onEnter,
    autoFocus,
    edit = true,
    disabled = false,
  } = props;
  const variant = edit ? 'outlined' : 'standard';

  const prepend = field.prepend
    ? {
        startAdornment: (
          <InputAdornment position="start">{field.prepend}</InputAdornment>
        ),
      }
    : null;
  const append = field.append
    ? {
        endAdornment: (
          <InputAdornment position="end">{field.append}</InputAdornment>
        ),
      }
    : null;
  // const options = field.lookup ? lookups.filter(l => l.type === field.lookup).map(l => ({ value:l.id, label:l.name, group: l.group })) : field.options;
  const selectedValue = zeroIsOk(_.get(values, field.name));
  const clear =
    field.clearable && selectedValue !== ''
      ? {
          startAdornment: (
            <InputAdornment
              className="clickable"
              position="start"
              onClick={() => field.clearable(null)}
            >
              <Icon.Clear />
            </InputAdornment>
          ),
        }
      : null;

  if (field.bool) {
    return (
      <>
        <FormControl component="fieldset" className="pt2">
          {field.legend && (
            <FormLabel component="legend">{field.legend}</FormLabel>
          )}
          <FormControlLabel
            control={
              <Checkbox
                color={edit ? 'primary' : 'default'}
                disabled={disabled || field.disabled}
                checked={!!_.get(values, field.name)}
                onChange={(e) =>
                  edit &&
                  setValues({ [field.name]: e.target.checked ? 1 : null })
                }
              />
            }
            label={field.label}
          />
          {field.boolExtra}
        </FormControl>
        {errors && !!errors[field.name] && (
          <FormHelperText error>{errors[field.name]}</FormHelperText>
        )}
      </>
    );
  }
  if (field.filterable) {
    return (
      <Autocomplete
        options={field.options}
        // defaultValue={selectedValue}
        onChange={(e, value: any) => {
          setValues({ [field.name]: value.id });
          // if (field.options) {
          //   const t = _.find(field.options, { value: value });
          //   field.onChange?.(t);
          // }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            autoComplete="off"
            autoFocus={autoFocus === true}
            disabled={disabled || field.disabled}
            required={edit && field.validate && field.validate.required}
            // name={field.name}
            label={field.label}
            value={selectedValue}
            variant={variant}
            className={field.className}
            style={field.style}
            // onBlur={(e) => {
            //   if (field.phone) {
            //     setValues({ [field.name]: formatPhone(e.target.value) });
            //   }
            //   if (field.number) {
            //     if (e.target.value.trim() === '') {
            //       setValues({ [field.name]: '' });
            //     } else {
            //       setValues({ [field.name]: Number(e.target.value) });
            //     }
            //   }
            // }}

            fullWidth={field.fullWidth ?? true}
            error={errors && !!errors[field.name]}
            helperText={(errors && errors[field.name]) || field.helperText}
          ></TextField>
        )}
      />
    );
  }

  return (
    <TextField
      autoComplete="off"
      autoFocus={autoFocus === true}
      disabled={disabled || field.disabled}
      required={edit && field.validate && field.validate.required}
      select={!!field.foreignKey || !!field.options}
      name={field.name}
      label={field.label}
      value={selectedValue}
      variant={variant}
      className={field.className}
      style={field.style}
      onBlur={(e) => {
        if (field.phone) {
          setValues({ [field.name]: formatPhone(e.target.value) });
        }
        if (field.number) {
          if (e.target.value.trim() === '') {
            setValues({ [field.name]: '' });
          } else {
            setValues({ [field.name]: Number(e.target.value) });
          }
        }
      }}
      onChange={(e) => {
        if (
          field.number &&
          !isNumeric(e.target.value) &&
          e.target.value.trim() !== ''
        ) {
          return;
        }
        setValues({ [field.name]: e.target.value });
        if (field.options) {
          const t = _.find(field.options, { value: e.target.value });
          field.onChange && field.onChange(t);
        }
      }}
      type={field.password ? 'password' : 'text'}
      fullWidth={field.fullWidth ?? true}
      multiline={!!field.multiline}
      maxRows={field.multiline || 6}
      minRows={field.multiline || 1}
      InputProps={{
        ...(prepend || append || clear),
        readOnly: !!field.readOnly || !edit,
      }}
      error={errors && !!errors[field.name]}
      helperText={(errors && errors[field.name]) || field.helperText}
      // onKeyDown={(ev) => {
      //   console.log({ key: ev.key });
      //   if (ev.key === 'Enter' && !field.multiline) {
      //     ev.preventDefault();
      //   }
      // }}
      // onKeyUp={(ev) => {
      //   if (ev.key === 'Enter' && !field.multiline) {
      //     onEnter?.();
      //     // ev.preventDefault();
      //   }
      // }}
    >
      {field.options &&
        field.options.map((o: any, i: number) => {
          return (
            <MenuItem key={`menuitem${i}`} value={o.value}>
              {o.label}
            </MenuItem>
          );
        })}
    </TextField>
  );
};

export default Input;
